<template>
    <client-page>

        <sub-visual
        sh="What We Do"
        tabActive="Quality Control"
        bg="/images/sub/visual/sv4.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <div class="page-tit-wrap">
                    <h2 class="page-tit">
                        Quality Control
                    </h2>
                    <p>
                        Systematic and efficient quality management system operation <br class="d-none d-lg-block">
                        of the entire process according to the quality management system procedure <br>
                        Securing stable quality through trend analysis through the SPC system
                    </p>
                </div>
            </v-container>
        </section>

        <section class="sub-section sub-section--last">
            <v-container>
                <sub-line-layout tit="Quality Control System">
                    <v-img src="/images/sub/wwd/control/control-img-en.png" max-width="940" class="mx-auto d-none d-md-block"></v-img>
                    <v-img src="/images/sub/wwd/control/control-img-mo-en.png" max-width="670" class="mx-auto d-block d-md-none"></v-img>
                </sub-line-layout>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/en/sub/sub-line-layout.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
    },
};
</script>

<style lang="scss" scoped>
</style>